import { Context, Data, Effect, Layer } from "effect";

import type { ClerkAdapter } from "./adapter";

export class NoSession extends Data.TaggedError("NoSession") {}

/** Token provider for HTTP Commands (KTD4). Reads the session at call time, never at Layer build. */
export class ClerkTokenService extends Context.Service<
	ClerkTokenService,
	{ readonly getToken: Effect.Effect<string, NoSession> }
>()("ClerkTokenService") {}

export const makeClerkTokenLayer = (
	adapter: Pick<ClerkAdapter, "getToken">,
): Layer.Layer<ClerkTokenService> =>
	Layer.succeed(ClerkTokenService)({
		getToken: Effect.promise(() => adapter.getToken()).pipe(
			Effect.flatMap((token) =>
				token === null ? Effect.fail(new NoSession()) : Effect.succeed(token),
			),
		),
	});

/** For API tests: each call yields the next token in `sequence` (the last one repeats); `null` fails with NoSession. */
export const makeTestTokenLayer = (
	sequence: ReadonlyArray<string | null>,
): Layer.Layer<ClerkTokenService> => {
	let index = 0;
	return makeClerkTokenLayer({
		getToken: () => {
			const token = sequence[Math.min(index, sequence.length - 1)] ?? null;
			index += 1;
			return Promise.resolve(token);
		},
	});
};
